import { Component } from '@angular/core';
import { COMMON_IMPORTS } from '../../Shared/common-imports';
import { ListDevicesFacade } from '../../../Facades/Intune/list-devices.facade';

@Component({
  selector: 'app-devices',
  imports: [COMMON_IMPORTS],
  templateUrl: './devices.component.html',
  styleUrl: './devices.component.scss',
})
export class DevicesComponent { }
